import { ModulesMap, ModulesConfigMap } from "../data/modulesMaps";

export default {
  getReportsFinanceByRoles: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_ROLES].GET_REPORTS_FINANCE_BY_ROLES
  }
}